import Vue from "vue";
import { authState } from "./auth";
import { getCurrentSpaceBilling } from "./membershipCatalog";

export const memberBillingState = Vue.observable({
  loading: false,
  loaded: false,
  spaceId: "",
  overview: null,
});

let memberBillingRequest = null;

function currentSpaceID() {
  return authState.session
    && authState.session.current_space
    && authState.session.current_space.id
    ? String(authState.session.current_space.id).trim()
    : "";
}

export function clearMemberBillingOverview() {
  memberBillingState.loading = false;
  memberBillingState.loaded = false;
  memberBillingState.spaceId = "";
  memberBillingState.overview = null;
  memberBillingRequest = null;
}

export async function refreshMemberBillingOverview({ force = false } = {}) {
  const spaceId = currentSpaceID();
  if (!spaceId) {
    clearMemberBillingOverview();
    return null;
  }
  if (!force && memberBillingState.loaded && memberBillingState.spaceId === spaceId) {
    return memberBillingState.overview;
  }
  if (memberBillingState.loading && memberBillingRequest) {
    return memberBillingRequest;
  }

  memberBillingState.loading = true;
  memberBillingState.spaceId = spaceId;
  memberBillingRequest = getCurrentSpaceBilling(spaceId)
    .then((payload) => {
      memberBillingState.overview = payload && payload.billing ? payload.billing : null;
      memberBillingState.loaded = true;
      return memberBillingState.overview;
    })
    .catch((error) => {
      memberBillingState.overview = null;
      memberBillingState.loaded = false;
      memberBillingState.spaceId = "";
      throw error;
    })
    .finally(() => {
      memberBillingState.loading = false;
      memberBillingRequest = null;
    });

  return memberBillingRequest;
}

export function resolveMemberIdentityLabel(user, overview) {
  if (user && user.is_platform_admin) {
    return "平台管理员";
  }

  const levelCode = overview && overview.level_code ? String(overview.level_code).trim() : "";
  if (!levelCode || levelCode === "free") {
    return "普通用户";
  }

  const subscription = overview && overview.subscription ? overview.subscription : null;
  const status = subscription ? String(subscription.status || "").trim().toLowerCase() : "";

  const levelNames = { personal: "个人会员", team: "团队会员" };
  const levelName = levelNames[levelCode] || levelCode;

  switch (status) {
    case "trial":
      return `${levelName}（试用中）`;
    case "past_due":
      return `${levelName}（待续费）`;
    default:
      return levelName;
  }
}
